module.exports = __webpack_public_path__ + "static/motor-99353083ff442d629fd87ca7168aa6dd.png";